import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import renderCell from "./renderCell";

export default function Tables({ data }) {
  const [keys, setKeys] = useState([]);
  const [head, setHead] = useState([]);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (data) {
      if (data.head) {
        setKeys(data.head.map((h) => h.key));
      }
      setHead(data.head || []);
      setRows(data.rows || []);
    }
  }, [data]);

  return (
    <div className="table-responsive">
      <table className="table table-nowrap datatable">
        <thead className="thead-light">
          <tr>
            {head.map((item, index) => (
              <th key={index}>{item.label}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.length > 0 &&
            rows.map((item, rowIndex) => (
              <tr key={rowIndex}>
                {keys.map((key, colIndex) => (
                  <td key={colIndex}>{renderCell(key, item[key])}</td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
